import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Me } from '@/types/auth';

interface AuthState {
  me: Me | null;
  hydrated: boolean;
}

const initialState: AuthState = { me: null, hydrated: false };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setMe(state, action: PayloadAction<Me>) {
      state.me = action.payload;
      state.hydrated = true;
    },
    setHydrated(state) {
      state.hydrated = true;
    },
    logout(state) {
      state.me = null;
      state.hydrated = true;
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
